import { storageRef } from "../../environment/firebase"
import { IStorageFile } from "../../models/IStorage";



const uplaodFile = async (path: string, file: File) => {

    const storage = storageRef()
    const ref = storage.ref(path);

    await ref.put(file);
    const url = await ref.getDownloadURL();

    const ret: IStorageFile = {
        path,
        url
    }

    return ret;
}

const StorageService = {
    uplaodFile
}


export default StorageService